// extracted by mini-css-extract-plugin
export default {"container":"TalkProject_container__uA-pX","header-wrapper":"TalkProject_header-wrapper__xJcO+"};